import { useEffect, useState } from "react";
import { uploads, watermarkDefault } from "../lib/uploads";
import { useToast } from "./Toast";

const ACCEPT = /^(video|image)\//;
const hasFiles = (e: DragEvent) => Array.from(e.dataTransfer?.types ?? []).includes("Files");

/** Drop video or stills anywhere in Manos Studio to start uploading. */
export function DropZone() {
  const [over, setOver] = useState(false);
  const toast = useToast();

  useEffect(() => {
    let depth = 0;
    const enter = (e: DragEvent) => {
      if (!hasFiles(e)) return;
      e.preventDefault();
      depth++;
      setOver(true);
    };
    const overHandler = (e: DragEvent) => {
      if (!hasFiles(e)) return;
      e.preventDefault();
      if (e.dataTransfer) e.dataTransfer.dropEffect = "copy";
    };
    const leave = (e: DragEvent) => {
      if (!hasFiles(e)) return;
      if (--depth <= 0) {
        depth = 0;
        setOver(false);
      }
    };
    const drop = (e: DragEvent) => {
      if (!hasFiles(e)) return;
      e.preventDefault();
      depth = 0;
      setOver(false);
      const all = Array.from(e.dataTransfer?.files ?? []);
      const ok = all.filter((f) => ACCEPT.test(f.type) || /\.(mov|mxf|mkv|tiff?|heic)$/i.test(f.name));
      if (ok.length < all.length) toast(`Skipped ${all.length - ok.length} file(s) that aren't video or images`, "error");
      if (ok.length) uploads.add(ok, { watermark: watermarkDefault.get() });
    };
    window.addEventListener("dragenter", enter);
    window.addEventListener("dragover", overHandler);
    window.addEventListener("dragleave", leave);
    window.addEventListener("drop", drop);
    return () => {
      window.removeEventListener("dragenter", enter);
      window.removeEventListener("dragover", overHandler);
      window.removeEventListener("dragleave", leave);
      window.removeEventListener("drop", drop);
    };
  }, [toast]);

  if (!over) return null;
  return (
    <div className="dropzone" aria-hidden="true">
      <div>
        <b>Drop to upload</b>
        <span>Video and stills go to Media and start processing right away</span>
      </div>
    </div>
  );
}
